export function resizeVendorPlayer(sdk, root, { preview = false, expanded = false } = {}) {
  const phoneElement = sdk?.phoneDom ? document.getElementById(sdk.phoneDom) : null
  if (!root?.isConnected || sdk?.dom !== root.id || !phoneElement
    || !root.contains(phoneElement) || typeof sdk.resizePhone !== 'function'
    || !sdk.phone || !(sdk.videoinfo?.width > 0) || !(sdk.videoinfo?.height > 0)
    || !root.clientWidth || !root.clientHeight) return false

  if (!preview) {
    // Match Android's local presentation without rotating the remote device.
    // This also keeps the SDK's touch coordinates in sync with the picture.
    sdk.setScreenOrientation(0)
    sdk.phone.topOff = 0
    phoneElement.style.margin = '0'
  }
  sdk.resizePhone()

  if (!preview && expanded) {
    Object.assign(sdk.phone, {
      width: root.clientWidth,
      height: root.clientHeight,
      pWidth: root.clientWidth,
      pHeight: root.clientHeight,
      letfOff: 0,
      topOff: 0,
      offSetx: 0,
      offSety: 0
    })
    Object.assign(phoneElement.style, {
      width: `${root.clientWidth}px`,
      height: `${root.clientHeight}px`,
      margin: '0'
    })
  }
  return true
}
